<template>
  <div class="stage">
    <div class="blobs" aria-hidden="true">
      <span class="blob b1"></span>
      <span class="blob b2"></span>
      <span class="blob b3"></span>
      <span class="blob b4"></span>
    </div>

    <div class="stage-inner">
      <p class="kicker">Rainbow Manager</p>
      <h1>{{ t('contacts') }}</h1>
      <p class="lead">{{ t('contactsLead') }}</p>

      <div class="card">
        <section class="contact">
          <span class="description">{{ t('ideaAndSuggestions') }}</span>
          <a class="contact-item" href="mailto:info@rainbow-manager.com">
            <font-awesome-icon :icon="['fas', 'envelope']" />
            <span>info@rainbow-manager.com</span>
          </a>
          <span class="description">{{ t('supportAndAssistance') }}</span>
          <a class="contact-item" href="mailto:support@rainbow-manager.com">
            <font-awesome-icon :icon="['fas', 'envelope']" />
            <span>support@rainbow-manager.com</span>
          </a>
        </section>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  setup() {
    const { t } = useI18n();
    return {
      t,
    };
  },
});
</script>
<style scoped lang="scss">
.stage {
  position: relative;
  isolation: isolate;
  min-height: 100%;
  display: flex;
  align-items: safe center;
  justify-content: center;
  padding: 32px 28px 64px;
  color: #f6f3ee;
  background: #141018;
}

.blobs {
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
  pointer-events: none;
}

.blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(70px);
  opacity: 0.55;
  animation: blob-drift 22s ease-in-out infinite;
}

.b1 {
  width: 48vw;
  height: 48vw;
  left: -8%;
  top: -18%;
  background: #fa496e;
  animation-duration: 18s;
}

.b2 {
  width: 42vw;
  height: 42vw;
  right: -10%;
  top: 8%;
  background: #a67eff;
  animation-duration: 24s;
  animation-direction: reverse;
}

.b3 {
  width: 38vw;
  height: 38vw;
  left: 18%;
  bottom: -16%;
  background: #52dbff;
  animation-duration: 20s;
}

.b4 {
  width: 28vw;
  height: 28vw;
  right: 18%;
  bottom: 8%;
  background: #a67eff;
  opacity: 0.7;
  animation-duration: 16s;
  animation-direction: reverse;
}

.stage-inner {
  position: relative;
  z-index: 1;
  width: min(460px, 100%);
  text-align: center;
}

.kicker {
  margin: 0 0 16px;
  font-size: 11px;
  letter-spacing: 0.28em;
  text-transform: uppercase;
  color: rgba(246, 243, 238, 0.7);
}

h1 {
  margin: 0 auto 12px;
  font-size: clamp(2.2rem, 6vw, 3.4rem);
  font-weight: 600;
  line-height: 1.05;
  letter-spacing: -0.04em;
}

.lead {
  margin: 0 auto 28px;
  max-width: 36ch;
  font-size: 1.05rem;
  line-height: 1.55;
  color: rgba(246, 243, 238, 0.78);
}

.card {
  padding: 28px 24px 24px;
  border: 1px solid rgba(246, 243, 238, 0.16);
  border-radius: 20px;
  background: rgba(20, 16, 24, 0.28);
  text-align: left;
}

.contact {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.description {
  margin: 8px 0 0;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: rgba(246, 243, 238, 0.78);
}

.description:first-child {
  margin-top: 0;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border: 1px solid rgba(246, 243, 238, 0.16);
  border-radius: 16px;
  background: rgba(20, 16, 24, 0.48);
  color: #f6f3ee;
  font-size: 15px;
  text-decoration: none;
}

.contact-item:hover {
  border-color: rgba(246, 243, 238, 0.32);
  background: rgba(246, 243, 238, 0.08);
}

@keyframes blob-drift {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
  }

  50% {
    transform: translate(5%, 7%) scale(1.08);
  }
}

@media (max-width: 600px) {
  .stage {
    padding: 20px 18px 40px;
    align-items: flex-start;
  }

  .card {
    padding: 22px 18px 20px;
  }

  .contact-item {
    font-size: 14px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .blob {
    animation: none;
  }
}
</style>
